/**
 * @generated SignedSource<<c8db08588a86b1ea42622f9a1d5f85dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type bundledNewsletterItemNewsletter$data = ReadonlyArray<{
  readonly images: ReadonlyArray<{
    readonly title: string | null | undefined;
    readonly url: string;
  } | null | undefined> | null | undefined;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"signUpButtonNewsletter">;
  readonly " $fragmentType": "bundledNewsletterItemNewsletter";
}>;
export type bundledNewsletterItemNewsletter$key = ReadonlyArray<{
  readonly " $data"?: bundledNewsletterItemNewsletter$data;
  readonly " $fragmentSpreads": FragmentRefs<"bundledNewsletterItemNewsletter">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "bundledNewsletterItemNewsletter",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "signUpButtonNewsletter"
    }
  ],
  "type": "Newsletter",
  "abstractKey": null
};

(node as any).hash = "7769edef7da9fbb9aec787ecaff6cfb5";

export default node;
